'use client';

import {
  ClientHdpInteractiveModules,
  type ClientHdpInteractiveModulesProps,
  type ClientHdpModuleType,
} from './ClientHdpInteractiveModules';

export type { ClientHdpModuleType };

/**
 * This file is already a client boundary (its own chunk), so a nested
 * next/dynamic() here bought nothing — and the lazy boundary made React's
 * useId paths diverge between streaming SSR and hydration, warning on every
 * Constellation ToneIcon inside (e.g. the amenities status Tags).
 */
export function ClientHdpModuleGroup(props: ClientHdpInteractiveModulesProps) {
  return <ClientHdpInteractiveModules {...props} />;
}
